import { render, staticRenderFns } from "./minemessage.vue?vue&type=template&id=f242fb48&"
import script from "./minemessage.vue?vue&type=script&lang=js&"
export * from "./minemessage.vue?vue&type=script&lang=js&"
import style0 from "./minemessage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports